import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';

// TODO(@paprikka) Phase 2: open dedicated filter modal with updated filter UI instead of MobileSearchMenu
export function MobileSearchFilterButton() {
  const { i18n } = useI18n();

  return (
    <Button
      type="button"
      variant="tertiary-grey"
      icon={{ name: 'filters' }}
      aria-label={i18n('Open search filters')}
      // oxlint-disable-next-line no-alert
      onClick={() => window.alert('work in progress')}
    />
  );
}
